
export const buildAddressFromData = (data) => {
    const { street1, street2, city, state, zipCode } = data;

    const extraStreet = street2 ? `, ${street2}` : '';
    const cityStateZip = `${city}, ${state} ${zipCode}`;

    return `${street1}${extraStreet} ${cityStateZip}`;
}
